import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  CircularProgress,
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import React from 'react';

export const EmailValidationTable = ({
  userList,
  loading,
  setPage,
  page,
  setRowsPerPage,
  rowsPerPage,
  totalCount,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer sx={{ mt: 2, minWidth: '80vw', maxHeight: ' 70vh' }}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: '#111827',
                    position: 'sticky',
                    top: 0,
                  }}
                >
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Sub Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Account
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Domain
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold',color: 'white' }}>
                    Domain Age Days
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                    Smtp Provider
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: 'bold', color: 'white' }}
                  >
                    Validated Time
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userList.length > 0 ? (
                  userList?.map((validated, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {validated?.validationResponse.address}
                      </TableCell>
                      <TableCell
                        sx={{
                          color:
                            validated?.validationResponse.status === 'valid' ? '#22C55E	' : 'red',
                          fontWeight: 'bold',
                        }}
                      >
                        {validated?.validationResponse.status}
                      </TableCell>
                      <TableCell>
                        {validated?.validationResponse.sub_status}
                      </TableCell>
                      <TableCell>
                        {validated?.validationResponse.account || 'Unknown'}
                      </TableCell>
                      <TableCell>
                        {validated?.validationResponse.domain || 'Unknown'}
                      </TableCell>
                      <TableCell>
                        {validated?.validationResponse.domain_age_days ||
                          'Unknown'}
                      </TableCell>
                      <TableCell>
                        {validated?.validationResponse.smtp_provider ||
                          'Unknown'}
                      </TableCell>

                      <TableCell align="right">
                        {new Date(validated.createdAt).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ padding: 3 }}>
                      This user has not validated any emails yet.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </>
  );
};
